export const androidHowToUse = 'https://www.youtube.com/embed/dKV90bETyfQ';
export const iosHowToUse = 'https://www.youtube.com/embed/w5KK7T7URbA';
